import React from 'react';
import { connect } from 'dva';
import { CSSTransitionGroup } from 'react-transition-group';
import PropTypes from 'prop-types';
import actions from './actions';
import Info from '../../../assets/svg/Feather/Info';
import Loader from '../../Loader';
import noop from 'lodash-es/noop';
import styles from './MapToast.module.scss';
import X from '../../../assets/svg/Feather/X';

function MapToast(props) {
  const getIcon = () => {
    if (props.toast.loader) {
      return <Loader className={styles.toastLoader} active={true} small />;
    }

    if (props.toast.icon) {
      const IconCmp = props.toast.icon;
      return (
        <IconCmp
          color={props.toast.iconColor ? props.toast.iconColor : '#F37735'}
          width={14}
        />
      );
    } else {
      return (
        <Info
          color={props.toast.iconColor ? props.toast.iconColor : '#F37735'}
          width={14}
        />
      );
    }
  };

  const onClick = (e) => {
    if (props.toast.onClick != null) {
      props.toast.onClick(e);
    } else {
      noop();
    }
  };

  const containerClass = [
    styles.toastContainer,
    props.toast != null && props.toast.onClick != null
      ? styles.clickableToast
      : '',
  ].join(' ');

  return (
    <div className={styles.toastPlacementContainer}>
      <CSSTransitionGroup
        transitionName="toast"
        transitionEnterTimeout={200}
        transitionLeaveTimeout={200}
      >
        {props.toast != null && (
          <div className={containerClass}>
            {getIcon()}
            <p className={styles.toastText} onClick={onClick}>
              {props.toast.text}
            </p>
            {
              props.toast.dismissable ? (
                <button className={styles.dismiss} onClick={props.dismiss}>
                  <X width={14} />
                </button>
              ) : // <span className={styles.dismiss} onClick={props.dismiss}>Cancel</span> :
              null
              // <X color='rgba(0,0,0,0)' width="14" height="14" />
            }
          </div>
        )}
      </CSSTransitionGroup>
    </div>
  );
}

MapToast.propTypes = {
  toast: PropTypes.object,
  // actions
  dismiss: PropTypes.func,
};

export default connect((model) => {
  return {
    toast: model.toast.message,
  };
}, actions)(MapToast);
